import React, { useState, useEffect, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { getBrands, addBrand, updateBrand, deleteBrand } from '../../utils/api';
import { BrandModal } from './BrandModal';

export const BrandsPage = () => {
    const [rowData, setRowData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [currentBrand, setCurrentBrand] = useState(null);
    const gridRef = useRef();

    useEffect(() => {
        fetchBrands();
    }, []);

    const fetchBrands = async () => {
        try {
            const res = await getBrands();
            setRowData(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const columnDefs = [
        { field: 'id', headerName: 'ID', filter: true, sortable: true, minWidth: 80 },
        { field: 'name', headerName: 'Name', filter: true, sortable: true, flex: 2, minWidth: 120 },
        {
            field: 'image',
            headerName: 'Image',
            cellRenderer: (params) => <img src={params.value} alt={params.data.name} className="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded" />,
            width: 90,
            minWidth: 80
        },
        { field: 'created_at', headerName: 'Created', filter: 'agDateColumnFilter', sortable: true, minWidth: 120 },
        {
            headerName: 'Actions',
            cellRenderer: (params) => (
                <div className="flex flex-wrap gap-1 sm:gap-2">
                    <button onClick={() => handleEdit(params.data)} className="px-2 py-1 bg-blue-500 text-white rounded text-xs sm:text-sm">Edit</button>
                    <button onClick={() => handleDelete(params.data.id)} className="px-2 py-1 bg-red-500 text-white rounded text-xs sm:text-sm">Delete</button>
                </div>
            ),
            width: 140,
            minWidth: 120
        }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true
    };

    const onGridReady = (params) => {
        gridRef.current.api = params.api;
    };

    const handleAdd = () => {
        setIsEdit(false);
        setCurrentBrand(null);
        setShowModal(true);
    };

    const handleEdit = (brand) => {
        setIsEdit(true);
        setCurrentBrand(brand);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure?')) {
            try {
                await deleteBrand(id);
                fetchBrands();
            } catch (err) {
                console.error(err);
            }
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
        setCurrentBrand(null);
    };

    const handleModalSubmit = async (formData) => {
        try {
            if (isEdit && currentBrand) {
                await updateBrand(currentBrand.id, formData);
            } else {
                await addBrand(formData);
            }
            fetchBrands();
            handleModalClose();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="bg-white p-3 sm:p-4 md:p-6 rounded-lg shadow">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4 sm:mb-6">
                <h1 className="text-xl sm:text-2xl font-bold">Brands</h1>
                <button onClick={handleAdd} className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded text-sm sm:text-base w-full sm:w-auto">Add Brand</button>
            </div>
            <div className="ag-theme-alpine w-full overflow-x-auto" style={{ height: 'min(60vh, 500px)', width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    animateRows={true}
                />
            </div>
            <BrandModal
                show={showModal}
                onClose={handleModalClose}
                onSubmit={handleModalSubmit}
                isEdit={isEdit}
                currentItem={currentBrand}
            />
        </div>
    );
};